import * as React from "react";
import { IWithHistoryProp, withHistory } from "../../shared/hoc/with-history";
import { KMainFunctions } from "../../shared/utility/main-functions";
import KuikaButton from "../ui-kit/kuika-button/kuika-button";
import KuikaModalIconWrapper from "../ui-kit/kuika-modal-icon-wrapper";
import KuikaH4 from "../ui-kit/typography/H4/H4";
import KuikaText from "../ui-kit/typography/Text/Text";
import { AuthLogo } from "./auth-logo";

export interface IPasswordChangeSuccessState {
  resetPasswordErrorMessage: string;
  isLoading: boolean;
}

export interface IPasswordChangeSuccessProps {}

class PasswordChangeSuccess extends React.PureComponent<
  IPasswordChangeSuccessProps & IWithHistoryProp,
  IPasswordChangeSuccessState
> {
  private tokenString = "";

  constructor(props: IPasswordChangeSuccessProps & IWithHistoryProp) {
    super(props);
    this.state = {
      resetPasswordErrorMessage: "",
      isLoading: false
    };
    this.getToken();
  }

  componentDidMount = () => {
    if (this.tokenString === "") {
      this.setState({ resetPasswordErrorMessage: "Invalid token." });
    }
  };

  getToken = () => {
    if (this.props && this.props.navigator && this.props.navigator.location && this.props.navigator.location.search) {
      let idx = this.props.navigator.location.search.indexOf("token=");
      const idx2 = this.props.navigator.location.search.indexOf("&username");
      if (idx > -1 && idx2 > -1) {
        idx += 6;
        const token = this.props.navigator.location.search.substring(idx, idx2);
        this.tokenString = token;
      }
    }
  };

  goToLogin = () => {
    this.props.navigator.gotoLogin();
  };

  render() {
    const isMainAI = KMainFunctions.isMainAI();

    return (
      <div className="email-confirmation">
        <div className="email-confirmation__content">
          <div className="email-confirmation__top-section">
            <AuthLogo />

            <div className="email-confirmation__check-inbox-card">
              <div className="email-confirmation__title-row">
                <KuikaModalIconWrapper iconName="check" intent="success" />
                <KuikaH4>Success</KuikaH4>
              </div>

              <KuikaText className="email-confirmation__message-text">Your password successfully changed.</KuikaText>

              <div className="email-confirmation__return-btn">
                <KuikaButton type="tertiary" size="lg" uppercase onClick={this.goToLogin} style={{ width: "100%" }}>
                  Return to sign in
                </KuikaButton>
              </div>
            </div>
          </div>

          {!isMainAI && (
            <div className="email-confirmation__bottom-section">
              <KuikaButton
                type="text"
                size="sm"
                onClick={() => window.open("https://www.kuika.com/en/legal/privacy", "_blank")}
                uppercase
              >
                Privacy
              </KuikaButton>
              <KuikaButton
                type="text"
                size="sm"
                onClick={() => window.open("https://www.kuika.com/en/legal/terms", "_blank")}
                uppercase
              >
                Terms
              </KuikaButton>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const passwordChangeSuccess = withHistory<IPasswordChangeSuccessProps>(PasswordChangeSuccess);
export { passwordChangeSuccess as PasswordChangeSuccess };
